import Nullstack from 'nullstack';
export default function IconCurrencyAfghani({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-afghani",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 13h-3.5a3.5 3.5 0 1 1 3.5 -3.5v6.5h-7"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 19v2"
  }), " ");
}